import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate("/admin", { replace: true }); return; }
      try {
        await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      } catch {
        setError(true);
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-offwhite">
      <div className="text-center">
        {error ? (
          <p className="text-red-500">Authentication failed. <a href="/admin" className="underline">Try again</a></p>
        ) : (
          <p className="text-ink/60 animate-pulse">Signing you in...</p>
        )}
      </div>
    </div>
  );
}
